import { render, staticRenderFns } from "./TeachingMaterialCheckBox.vue?vue&type=template&id=ecd79f6e&scoped=true&"
import script from "./TeachingMaterialCheckBox.vue?vue&type=script&lang=js&"
export * from "./TeachingMaterialCheckBox.vue?vue&type=script&lang=js&"
import style0 from "./TeachingMaterialCheckBox.vue?vue&type=style&index=0&id=ecd79f6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd79f6e",
  null
  
)

export default component.exports